@if (pyChartData.data.length > 0) {
  <app-chart-pie [pyChartData]="pyChartData"
                 legendPosition="bottom" />
} @else {
  <div class="alarms-pie-chart-empty">
    <div class="empty-icon">
        <span class="material-symbols-rounded">
          check_circle
        </span>
    </div>
    <p class="empty-message">{{ 'common.messages.empty.no-alarms-available' | translateSafe }}</p>
  </div>
}
